import { ButtonHTMLAttributes } from 'react';

import styled from 'styled-components';
import { FaRegBell } from 'react-icons/fa';

import IconButton from 'components/ui/IconButton';

const UpdateIndicator = styled.div`
  position: absolute;
  top: 4px;
  right: 4px;
  width: 8px;
  height: 8px;
  background-color: #ff9f1a;
  border-radius: 100%;
`;

interface AlarmButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  isAlarmUpdated: boolean;
}

const AlarmButton = ({ isAlarmUpdated, ...rest }: AlarmButtonProps) => {
  return (
    <IconButton $iconSize={24} $size={46} $hasRadius {...rest}>
      {isAlarmUpdated && <UpdateIndicator></UpdateIndicator>}
      <FaRegBell />
    </IconButton>
  );
};

export default AlarmButton;
